import { render, staticRenderFns } from "./veHqBaoxiuShow.vue?vue&type=template&id=f8e5b852&scoped=true"
import script from "./veHqBaoxiuShow.vue?vue&type=script&lang=js"
export * from "./veHqBaoxiuShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e5b852",
  null
  
)

export default component.exports